/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    interface IMeevoOwnershipBusinessTypeScope extends ng.IScope{
        contextData: Object,
        hideTakeOwnership: boolean,
        hideAvailableToLocation: boolean,
        ownershipLayoutRow: boolean,
        tabIndex: number,
        parseTab: Function,
        contentKeys?: {
            businessType?: string,
            takeOwnership?: string,
            availableToLocations?: string
        }
    }
    export class MeevoOwnershipBusinessType implements angular.IDirective {
        restrict = "E";
        scope = {
            contextData: "=",
            hideTakeOwnership: "=",
            hideAvailableToLocation: "=",
            contentKeys: "=?",
            ownershipLayoutRow: "<?",
            tabIndex: "=?"
        };

        templateUrl = "app/components/controls/ownershipBusinessTypeTemplate.html";

        link = (scope: IMeevoOwnershipBusinessTypeScope) => {
            scope.ownershipLayoutRow = false;
            scope.contentKeys = scope.contentKeys || {};
            let {businessType, takeOwnership, availableToLocations} = scope.contentKeys;
            scope.contentKeys.businessType = businessType || 'LABEL_BUSINESS_TYPE';
            scope.contentKeys.takeOwnership = takeOwnership || 'LABEL_TAKE_OWNERSHIP';
            scope.contentKeys.availableToLocations = availableToLocations || 'LABEL_CO_AVAILABLETOLOCATIONS';
            if (scope.tabIndex == undefined) {
                scope.tabIndex = 75;
            }
            scope.parseTab = function(numToAdd) {
                return scope.tabIndex + parseInt(numToAdd)
            }
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoOwnershipBusinessType();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoOwnershipBusinessType", MeevoOwnershipBusinessType.factory());
}